export default {
  name: 'PrivacyPolicyComponent'
};